import { useQuery } from '@tanstack/react-query';
import { getAxios } from '../../../../util/axios';
import { apiRoutes } from '../../../../constants/apiRoutes';
import { JobSearchResult } from '../types/JobSearchResult';

export function useJobSearchQuery(term: string) {
  return useQuery({
    queryKey: ['jobSearch', term],
    queryFn: async () => (await getAxios().get<JobSearchResult[]>(apiRoutes.jobs.search(term))).data,
    enabled: term.length >= 2,
    staleTime: 30_000
  });
}
